export const LABELS = {
	run: 'Run:',
	job: 'Job:',
	ridePlannedDeparture: 'Ride planned departure:',
	ridePlannedArrival: 'Ride planned arrival:',
	assignmentStart: 'Planned assignment start:',
	assignmentEnd: 'Planned assignment end:',
	duration: 'Duration',
	reconciliation: 'Reconciliation',
	rides: 'Rides:',
	extraActivitiesTitle: 'Work assignment extra activities:',
	noExtraActivities: 'No extra activities',
	scrollLeft: 'Scroll left',
	scrollRight: 'Scroll right',
	driverIdPrefix: '(ID: ',
	driverIdSuffix: ')',
	notAssigned: '(Not assigned)',
	previouslyAssigned: 'Previously assigned',
	to: 'to',
	notAvailable: 'N/A',
};
